import React from "react";
import {Link} from "react-router-dom";

import HoverTarget from "./HoverTarget";

const HoverLink = HoverTarget.withComponent(Link);

export default HoverLink;